import './Atu2StatusCard.css';

type Tone = 'safe' | 'warn' | 'danger' | 'info' | 'muted';

export default function Atu2StatusCard({
  label, internal, value, detail, tone = 'muted',
}: Props) {
  return (
    <article className={`atu2-status-card ${tone}`}>
      <div className="atu2-status-card-head">
        <span>{label}</span>
        {internal && <code>{internal}</code>}
      </div>
      <strong>{value}</strong>
      {detail && <p>{detail}</p>}
    </article>
  );
}

type Props = {
  label: string;
  internal?: string;
  value: string;
  detail?: string;
  tone?: Tone;
};
